import { ParsingError } from './parsing-error';

/** Ошибка недействительного аргумента */
export class InvalidArgumentError extends ParsingError {
    constructor(argument: string) {
        super(`argument "${argument}" is invalid`);
        this.name = 'InvalidArgumentError';
    }
}
